import Gauge from "components/Guage/Guage";
import SelectHorseScore from "assets/icons/select_horse_details.svg?react";
import { useAuthStore } from "stores/auth/authStore";
import { Modal, useModalStore } from "stores/modal/useModalStore";

export const ScoreSection = ({
  selectedHorseStatus,
  filteredScore,
}) => {
  const user = useAuthStore((state) => state.user);
  const setIsAction = useAuthStore((state) => state.setIsAction);
  const openModal = useModalStore((state) => state.open);

  const content =
    selectedHorseStatus === "LIVE" ? (
      <>
        <div className="whats_your_horse_label">Your SaddleFit Score</div>
        <Gauge
          style={{
            fontFamily: "Montserrat",
            fontWeight: "bold",
            width: 356.504,
            height: 162,
          }}
          score={Number.isFinite(filteredScore) ? filteredScore : 0}
          className="!h-[162px]"
        />
      </>
    ) : (
      <>
        <div className="whats_your_horse_label">
          What&apos;s Your Saddle Fit Score?
        </div>
        <SelectHorseScore
          onClick={() => {
            setIsAction("saddleDetails");
            if (!user) openModal(Modal.Login);
          }}
          className="cursor-pointer"
        />
      </>
    );

  return <div className="cactus_score_container">{content}</div>;
};
